import $ from 'jquery';
import RecordAction from '../RecordAction';
import Release from 'components/framework/models/Release';
import FeatureCardRepositioner from 'javascripts/feature_card_repositioner';
import terminology from 'javascripts/terminology';
import type { Epic, Feature } from 'components/framework/models';
import type ApplicationModel from 'components/framework/ApplicationModel';

type RecordType = Feature | Epic;

export class MoveToReleaseAction extends RecordAction<RecordType> {
  recordTypes = ['Feature', 'Epic'];

  get title() {
    return `Move to ${terminology('release')}`;
  }

  get hasSubmenu() {
    return true;
  }

  async prepareSubmenuItems() {
    const availableReleases = await Release.select('id', 'name')
      .where({ active: true, projectId: window.currentProjectId })
      .all();

    return availableReleases.map(release => ({
      label: release.name,
      data: release,
    }));
  }

  showForRecord(record: ApplicationModel): record is RecordType {
    return super.showForRecord(record) && !window.currentProject?.isTeam;
  }

  async runForRecords(records: RecordType[], { id }) {
    FeatureCardRepositioner.moveToBottom(
      id,
      records.map(r => r.referenceNum)
    );
    for (const record of records) {
      const prefix = record.typename.toLowerCase();
      $(`#release_${id},#master_release_${id}`).append(
        $(`#${prefix}_${record.id}`)
      );
    }
  }
}
